import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const StaffGradFairRemoveFromWaitlistModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "StaffGradFairRemoveFromWaitlistModalContainer" */
      './StaffGradFairRemoveFromWaitlistModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
